import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { FaCalendarAlt } from "react-icons/fa";

const DateInput = ({ value, onChange }) => {
  return (
    <div className="date-input-wrapper" style={{ position: "relative" }}>
      <DatePicker
        selected={value && !isNaN(new Date(value)) ? new Date(value) : null}
        onChange={(date) =>
          onChange(date ? moment(date).format("YYYY-MM-DD") : "")
        }
        dateFormat="dd-MM-yyyy"
        className="form-control form-control-sm"
        placeholderText="DD-MM-YYYY"
        dropdownMode="select"
        onChangeRaw={(e) => {
          if (!e || !e.target) return;

          let inputVal = e.target.value;
          if (typeof inputVal !== "string") return;

          let val = inputVal.replace(/[^0-9]/g, "");

          if (val.length > 2) val = val.slice(0, 2) + "-" + val.slice(2);
          if (val.length > 5) val = val.slice(0, 5) + "-" + val.slice(5, 9);

          const parts = val.split("-");
          let day = parts[0];
          let month = parts[1];
          let year = parts[2];

          if (month && parseInt(month) > 12) month = "12";

          if (year && year.length === 4) {
            const y = parseInt(year);
            if (y < 1000) year = "1000";
            if (y > 9999) year = "9999";
          }

          if (day && month) {
            const y = year && year.length === 4 ? parseInt(year) : 2024;
            const maxDays = new Date(y, parseInt(month), 0).getDate();

            if (parseInt(day) > maxDays) {
              day = String(maxDays);
            }
          }

          let formatted = day || "";
          if (month) formatted += "-" + month;
          if (year) formatted += "-" + year;

          e.target.value = formatted;
        }}
      />
      <FaCalendarAlt
        size={16}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "#6c757d",
        }}
      />
    </div>
  );
};

export default DateInput;
